import React from 'react';
import { change, FieldArray } from 'redux-form';
import LensType from './LensType';
import { connect } from 'react-redux';
import OSGlass from './glass/OSGlass';
import ODGlass from './glass/ODGlass';

let Glass = props => {
  const { currentStoreOtherDetails, currentEyeglass, member, pprops, pprops: { dispatch } } = props;

  const updateCorrespondingAxisValue = (e, member, glassType) => {
    if (["DS", " "].includes(e?.target?.value)) {
      dispatch(change('orderEyeglassForm', `${member}[${glassType}_glass_details][axis]`, null))
    }
  }

  const copyTo = (source, destination) => {
    // let eyeglasses_attributes = currentEyeglassAttributes
    let sourceObj = eval(`${member}.${source}_glass_details`);
    dispatch(change('orderEyeglassForm', `${member}[${destination}_glass_details][sphere]`, sourceObj.sphere))
    dispatch(change('orderEyeglassForm', `${member}[${destination}_glass_details][cylinder]`, sourceObj.cylinder))
    dispatch(change('orderEyeglassForm', `${member}[${destination}_glass_details][axis]`, sourceObj.axis))
    dispatch(change('orderEyeglassForm', `${member}[${destination}_glass_details][add]`, sourceObj.add))
    dispatch(change('orderEyeglassForm', `${member}[${destination}_glass_details][prism]`, sourceObj.prism))
    dispatch(change('orderEyeglassForm', `${member}[${destination}_glass_details][segment_height]`, sourceObj.segment_height))
    dispatch(change('orderEyeglassForm', `${member}[${destination}_glass_details][base_curve]`, sourceObj.base_curve))
  }

  const renderEyeFieldLabel = (fieldType) => {
    let destination = fieldType === 'od' ? 'os' : 'od'
    return <span>
      Eye
      <small className='text-primary btn-link pointer ml-8' onClick={() => copyTo(fieldType, destination)}>{destination.toUpperCase()}<i className="las la-copy btn-link" /></small>
    </span>
  }

  return (
    <div className="col-12 p-6">
      <div className="row">
        {(currentEyeglass.od_stock_lens_amount_on_hand && currentStoreOtherDetails?.stock_lens) ? <span className="badge badge-info badge-pill pointer font-size-14 ml-4 mt-6" style={{ height: 22 }} title='Stock Lens Amount in Hand'>
          {currentEyeglass.od_stock_lens_amount_on_hand}
        </span> : ''}
        {currentStoreOtherDetails?.stock_lens && <>
          <FieldArray
            name={`${member}.lens_types_attributes`}
            props={{
              pprops: pprops,
              member: member,
              currentEyeglass: currentEyeglass,
              eyeTestType: 'od',
              glassModule: true
            }}
            component={LensType}
          />
          <div className="col-12" />
        </>}
        <ODGlass
          member={member}
          updateCorrespondingAxisValue={updateCorrespondingAxisValue}
          renderEyeFieldLabel={renderEyeFieldLabel}
        />
      </div>

      {currentStoreOtherDetails?.stock_lens && <hr />}

      <div className="row">
        {(currentEyeglass.os_stock_lens_amount_on_hand && currentStoreOtherDetails?.stock_lens) ? <span className="badge badge-info badge-pill pointer font-size-14 ml-4 mt-6" style={{ height: 22 }} title='Stock Lens Amount in Hand'>
          {currentEyeglass.os_stock_lens_amount_on_hand}
        </span> : ''}
        {currentStoreOtherDetails?.stock_lens && <>
          <FieldArray
            name={`${member}.lens_types_attributes`}
            props={{
              pprops: pprops,
              member: member,
              currentEyeglass: currentEyeglass,
              eyeTestType: 'os',
              glassModule: true
            }}
            component={LensType}
          />
          <div className="col-12" />
        </>}
        <OSGlass
          member={member}
          updateCorrespondingAxisValue={updateCorrespondingAxisValue}
          renderEyeFieldLabel={renderEyeFieldLabel}
        />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const { currentStore } = state
  return {
    currentStoreOtherDetails: currentStore.store?.other_details
  }
}

export default connect(mapStateToProps)(Glass);